import './TransparentPreventInteraction.scss';
import React from 'react';

const componentInfo = {
  name: 'TransparentPreventInteraction',
  className: 'transparent-prevent-interaction',
  useType: 'Content',
  componentType: 'Basc',
};
const TransparentPreventInteraction = ({
  loading,
  extent,
}: {
  loading: boolean;
  extent: 'page' | 'page-content';
}) => {
  return (
    <div
      className={`${componentInfo.className} ${
        loading ? 'is-loading' : 'not-loading'
      }  ${extent}-wide`}></div>
  );
};

export default TransparentPreventInteraction;
